import React, {Component} from "react";
import {SelectInput} from "../../../../components";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import ClaimStatusEnum from "./ClaimStatus";
import {Button, Col, Container, Row} from "react-bootstrap";


export default class ClaimStatusUpdateModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedStatus: props.status
        };
    }

    saveStatus = () => {
        if (!this.state.selectedStatus) {
            return;
        }

        RemotingService.postRemoteCall(
            `api/insurance/coordinator/claim/${this.props.claimId}/status`,
            {status: this.state.selectedStatus},
            () => {
                if (this.props.onSaved) {
                    this.props.onSaved();
                }
                if (this.props.close) {
                    this.props.close();
                }
            }
        );
    }

    render() {
        return (
            <Container style={{width: 400, padding: "20px"}}>
                <Row className="mb-3">
                    <Col>
                        <label className="font-weight-bold">Claim Status</label>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <SelectInput searchEnabled={false}
                                     displayProperty="name"
                                     valueProperty="key"
                                     options={ClaimStatusEnum.manualStatuses}
                                     value={this.state.selectedStatus}
                                     onChange={(value) => this.setState({selectedStatus: value})}/>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-right">
                        <Button variant="success"
                                disabled={!this.state.selectedStatus}
                                onClick={this.saveStatus}>
                            Save
                        </Button>
                    </Col>
                </Row>
            </Container>
        );
    }
}
